// Helper used to create subtypes for each redux dispatch action
export default (action) => ({
    REQUEST: `${action}_REQUEST`,
    SUCCESS: `${action}_SUCCESS`,
    FAILURE: `${action}_FAILURE`,
});
